exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "incident-list div.footer{display:block;position:absolute;right:2%;bottom:0}incident-list #incident_description{padding:0 2%;font-size:2.7vmin}incident-list news12-list .up-arrow .up{border-left:1.44vw solid transparent;border-right:1.44vw solid transparent;border-bottom:2vh solid #ffac25}incident-list news12-list .down-arrow .down{border-left:1.44vw solid transparent;border-right:1.44vw solid transparent;border-top:2vh solid #ffac25}incident-list .back-button{display:block;position:absolute;bottom:2%;right:50%}incident-list .back-button button{margin:0 auto}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./client/app/components/common/incidentList/incidentList.scss
 ** module id = 210
 ** module chunks = 0
 **/